import { render, staticRenderFns } from "./barMenu.vue?vue&type=template&id=0a47724b&scoped=true"
import script from "./barMenu.vue?vue&type=script&lang=js"
export * from "./barMenu.vue?vue&type=script&lang=js"
import style0 from "./barMenu.vue?vue&type=style&index=0&id=0a47724b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47724b",
  null
  
)

export default component.exports